import { useEffect } from 'react';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import { IconButton } from '@ds';

type LogisticsSliderProps = {
  totalCount: number;
  page: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
};

export const LogisticsSlider = ({ totalCount, page, itemsPerPage, onPageChange }: LogisticsSliderProps) => {
  const hasPagination = totalCount > itemsPerPage;
  const pages = Math.ceil(totalCount / itemsPerPage) - 1;

  const hasPrevPage = page > 0;
  const hasNextPage = page < pages;

  const handleNextPage = () => {
    onPageChange(page + 1);
  };

  const handlePrevPage = () => {
    onPageChange(page - 1);
  };

  useEffect(() => {
    if (pages < page) {
      onPageChange(pages);
    }
  }, [onPageChange, pages, page]);

  if (!hasPagination) {
    return null;
  }

  return (
    <div className="flex gap-1">
      <IconButton
        size="md"
        variant="light"
        startContent={<MdKeyboardArrowLeft size={16} />}
        isDisabled={!hasPrevPage}
        onPress={handlePrevPage}
      />
      <IconButton
        size="md"
        variant="light"
        startContent={<MdKeyboardArrowRight size={16} />}
        isDisabled={!hasNextPage}
        onPress={handleNextPage}
      />
    </div>
  );
};
